<template>
             <van-popup
              v-model="showPicker"
              round
              position="bottom"
              @click-overlay="onCancel"
            >
              <van-picker
                :title="title"
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="onCancel"
               
              />
            </van-popup>
</template>

<script>
export default {
props:{
    columns:{
        default:[],
        type:Array,
    },
    showPicker:{
        default:false,
        type:Boolean,
    },
    title:{
        default:"",
        type:String
    }
},
data(){
    return{

    }
},
methods:{
    onConfirm(value){
        this.$emit("selecteValue",value,false);
        console.log(2323)
    },
    onCancel(){
         this.$emit("closePop",false);
    },

}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/popup.vue